/**
 * MapiError - Custom error class for API errors
 * Migrated from Paperbits to work with Axios responses
 */

export interface SmapiErrorDetails {
    target: string;
    message: string;
}

export class MapiError extends Error {
    public correlationId?: string;

    constructor(
        public readonly code: string,
        public readonly message: string,
        public readonly details?: SmapiErrorDetails[]
    ) {
        super(message);
        this.name = 'MapiError';
        Object.setPrototypeOf(this, MapiError.prototype);
    }

    /**
     * Create MapiError from Axios error response
     * @param response - Axios error response data
     */
    public static fromResponse(response: any): MapiError {
        const responseData = response?.data || response;
        const code = responseData?.error?.code || responseData?.code || "Error";
        const message = responseData?.error?.message || responseData?.message || "Server error";
        const details = responseData?.error?.details || responseData?.details || [];

        return new MapiError(code, message, details);
    }

    public toString(): string {
        return `${this.code}: ${this.message}`;
    }
}